import { Toast } from 'vant'
import {
  sapList,
  squareDetail,
  sendSmsCode,
  squareEnroll,
  getInviteUserInfo,
  getConfig,
  submissionHub,
  getFunctionInfo,
  getCityList,
} from '@/api/talentSquare'
/**
 * 过滤参数
 * @param {*} data
 * @returns
 */
function filterParams(data) {
  // 过滤参数
  if (!data) {
    return {}
  }
  let cloneData = {}
  Object.keys(data).forEach((key) => {
    if (typeof data[key] != 'function') {
      cloneData[key] = data[key]
    }
  })
  return cloneData
}
const state = {
  talentList: [], // 候选人列表
  talentTotal: 0, // 候选人总数
  squareDetailInfo: null, // 候选人详情
  inviteUserInfo: null, // 顾问信息
  configInfo: null, // 报名-城市/行业配置信息
  cityList: [], // 配置城市列表
  functionList: [], // 配置职能列表
  functionInfo: [], // 职能列表
  cityInfo: [], // 城市列表
}

const mutations = {
  /**
   * 设置字段
   * @param {*} state
   * @param {*} data
   */
  setStateItem(state, data) {
    state[data.key] = data.value
  },
}
const actions = {
  /**
   * 人才广场列表
   * @param {*} param0
   * @param {*} data
   */
  async sapList({ state, commit }, data) {
    try {
      const res = await sapList({
        ...filterParams(data),
      })
      if (res.data.code == 200) {
        data.cb && data.cb(res.data.data)
      } else {
        Toast(res.data.message)
        data.cb && data.cb()
      }
    } catch (e) {
      console.log(e)
    }
  },
  /**
   * 候选人详情
   * @param {*} param0
   * @param {*} data
   */
  async squareDetail({ state, commit }, data) {
    try {
      const res = await squareDetail({
        ...filterParams(data),
      })
      if (res.data.code == 200) {
        let detail = res.data.data
        let tempList = []
        for (let i = 0; i < detail.project_experience.length; i++) {
          let item = detail.project_experience[i]
          if (
            item.project_start_time != 0 ||
            item.project_is_now ||
            item.project_end_time != 0 ||
            item.project_role ||
            item.project_name ||
            item.project_company ||
            item.project_describe ||
            item.project_performance
          ) {
            tempList.push(item)
          }
        }
        detail.project_experience = tempList
        commit('setStateItem', {
          key: 'squareDetailInfo',
          value: detail,
        })
        data.cb && data.cb(res.data.data)
      } else {
        Toast(res.data.message)
      }
    } catch (e) {
      console.log(e)
    }
  },
  /**
   * 人才报名-发送验证码
   * @param {*} param0
   * @param {*} data
   */
  async sendSmsCode({ state, commit }, data) {
    try {
      const res = await sendSmsCode({
        ...filterParams(data),
      })
      if (res.data.code == 200) {
        data.cb && data.cb(1)
      } else {
        data.cb && data.cb(2)
        Toast(res.data.message)
      }
    } catch (e) {
      console.log(e)
    }
  },
  /**
   * 意向提交
   * @param {*} param0
   * @param {*} data
   */
  async submissionHub({ state, commit }, data) {
    try {
      const res = await submissionHub({
        ...filterParams(data),
      })
      if (res.data.code == 200) {
        data.cb && data.cb()
      } else {
        Toast(res.data.message)
      }
    } catch (e) {
      console.log(e)
    }
  },
  /**
   * 人才报名-报名
   * @param {*} param0
   * @param {*} data
   */
  async squareEnroll({ state, commit }, data) {
    try {
      const res = await squareEnroll({
        ...filterParams(data),
      })
      if (res.data.code == 200) {
        data.cb && data.cb(1)
      } else {
        data.cb && data.cb(2)
        Toast(res.data.message)
      }
    } catch (e) {
      console.log(e)
    }
  },
  /**
   * 人才报名-获取顾问信息
   * @param {*} param0
   * @param {*} data
   */
  async getInviteUserInfo({ state, commit }, data) {
    try {
      const res = await getInviteUserInfo({
        ...filterParams(data),
      })
      if (res.data.code == 200) {
        commit('setStateItem', {
          key: 'inviteUserInfo',
          value: res.data.data,
        })
        data.cb && data.cb(res.data.data)
      } else {
        Toast(res.data.message)
      }
    } catch (e) {
      console.log(e)
    }
  },
  /**
   * 人才报名-行业/城市配置信息
   * @param {*} param0
   * @param {*} data
   */
  async getConfig({ state, commit }, data) {
    try {
      const res = await getConfig({
        ...filterParams(data),
      })
      if (res.data.code == 200) {
        commit('setStateItem', {
          key: 'cityList',
          value: res.data.data.city || [],
        })
        commit('setStateItem', {
          key: 'functionList',
          value: res.data.data.function || [],
        })
        data.cb && data.cb(res.data.data)
      } else {
        Toast(res.data.message)
      }
    } catch (e) {
      console.log(e)
    }
  },
  /**
   * 职能列表
   * @param {*} param0
   * @param {*} data
   */
  async getFunctionInfo({ state, commit }, data) {
    try {
      const res = await getFunctionInfo({
        ...filterParams(data),
      })
      if (res.data.code == 200) {
        commit('setStateItem', {
          key: 'functionInfo',
          value: res.data.data || [],
        })

        data.cb && data.cb(res.data.data)
      } else {
        Toast(res.data.message)
      }
    } catch (e) {
      console.log(e)
    }
  },
  /**
   * 城市列表
   * @param {*} param0
   * @param {*} data
   */
  async getCityList({ state, commit }, data) {
    try {
      const res = await getCityList({
        ...filterParams(data),
      })
      if (res.data.code == 200) {
        commit('setStateItem', {
          key: 'cityInfo',
          value: res.data.data || [],
        })

        data.cb && data.cb(res.data.data)
      } else {
        Toast(res.data.message)
      }
    } catch (e) {
      console.log(e)
    }
  },
}

export default {
  state,
  actions,
  mutations,
  namespaced: true,
}
